/* app/models/bento-box
Bento Box App Bento Box and derived models
*/

import Backbone from 'backbone';
import He from 'he';
import EventChannel from '../events.js';
import * as Utils from '../utils.js';
import { brokenFormBaseUrl } from '../config.js';


// Generic model for a BentoBox result.
const BentoBoxResult = Backbone.Model.extend({});

const BentoBox = Backbone.Collection.extend({
  // Generic BentoBox model, representing any of the bento box spaces
  // in our interface. Is a collection of BentoBoxResults.
  model: BentoBoxResult,
  totalCount: 0,
  newSearchUrl: '',
  fullResultsUrl: '',
  url: '',

  initialize: function(models, options) {
    this.url = `${BBAPI_URL}${options.url}`;
    this.type = options.type;
    this.searchEnabled = true;
    if (options.maxResults !== undefined) {
      this.maxResults = options.maxResults;
    } else {
      this.maxResults = 5;
    }
    this.otherFields = [];
    if (options.otherFields !== undefined) {
      this.otherFields = options.otherFields;
    }
    this.otherFields.push('newSearchUrl', 'fullResultsUrl');
    // NOTE: Now each collection is set to listen for the 'search' event
    // in the views.BentoBoxView subview when that subview is initialized.
    // This way if only certain boxes are requested, we refrain from
    // requesting results from the invisible boxes.
    // this.listenTo(EventChannel, 'search', this.doSearch);
  },

  parse: function(response, options) {
    for (const field of this.otherFields) {
      if (response[field] !== undefined) {
        let value = response[field];
        if (value !== null && (field == 'newSearchUrl' || field == 'fullResultUrl')) {
          value = He.encode(value);
        }
        this[field] = value;
      }
    }
    this.totalCount = response.results === null ? 0 : response.results.length;
    let returnResults = response.results;

    // For articles results, we want to build needed URL for reporting broken
    // links and attach this to the model.
    if (this.type == 'articles' && returnResults !== null) {
      for (let r of returnResults) {
        let pstring = Object.entries({
          article_title: r.title,
          article_authors: r.authorList,
          publication: `${(r.issn !== null ? `ISSN: ${r.issn};` : '')}${r.citation}`,
          journal_title: r.journalTitle,
          issn: r.issn,
          date: r.date,
          volume: r.volume,
          issue: r.issue,
          pages: r.startPage || r.numPages,
          content_type: r.type,
          url: `https:${r.link}`,
          results_url: this.fullResultsUrl,
        })
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');
        r['brokenLinkUrl'] = `${brokenFormBaseUrl}?${pstring}`
      }
    }
    return returnResults;
  },

  disableSearch: function() {
    this.searchEnabled = false;
  },

  doSearch: function(vars) {
    // Reset all additional fields on the collection before searching
    for (const field of this.otherFields) {
      delete(this[field]);
    }
    delete(this.totalCount);
    if (this.searchEnabled) {
      this.fetch({
        data: {
          'search': vars.q,
          'limit': this.maxResults
        },
        success: function(model) {
          EventChannel.trigger(
            `bento-box-collection-success:${model.type}`,
            vars
          );
        },
        error: function(model) {
          EventChannel.trigger(
            `bento-box-collection-error:${model.type}`,
            vars
          );
        }
      });
    }
  },

});


export {
  BentoBoxResult as model,
  BentoBox as collection
};
